module.exports = __webpack_public_path__ + "static/img/image_title@2x.7c7ca1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktbPopularize/image_title@2x.png
// module id = OI7D
// module chunks = 69